import { ClipboardDocumentIcon } from '@heroicons/react/24/outline'
import { copyClipboard } from 'utils/copyClipboard'

type EmbedUrlStripProps = {
  path: string
  label?: string
}

export const EmbedUrlStrip = ({ path, label = 'Embed URL' }: EmbedUrlStripProps) => {
  const url = `${window.location.origin}${path}`
  const iframeSnippet = `<iframe src="${url}" style="width:100%;min-height:720px;border:0;" title="${label}"></iframe>`

  return (
    <div className="mb-4 rounded-lg border border-gray-200 bg-slate-50 p-4">
      <p className="text-sm font-semibold text-gray-800 mb-2">{label}</p>
      <div className="flex flex-col sm:flex-row sm:items-center gap-2">
        <code className="flex-1 text-xs sm:text-sm bg-white border border-gray-200 rounded px-3 py-2 break-all text-shade-blue">
          {url}
        </code>
        <button
          type="button"
          onClick={() => copyClipboard(url)}
          className="inline-flex items-center justify-center gap-1.5 px-3 py-2 text-sm font-medium rounded bg-shade-blue text-white hover:opacity-90"
        >
          <ClipboardDocumentIcon className="w-4 h-4" />
          Copy URL
        </button>
        <button
          type="button"
          onClick={() => copyClipboard(iframeSnippet)}
          className="inline-flex items-center justify-center gap-1.5 px-3 py-2 text-sm font-medium rounded border border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
        >
          Copy iframe
        </button>
      </div>
    </div>
  )
}
